export const isSupership = (level: number): boolean => level > 10;
